/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M304.42 68.2c-11.605-3.107-23.765 3.809-26.93 15.5l-89.491 332.765c-3.136 11.72 3.81 23.764 15.56 26.929 1.875.498 3.78.762 5.684.762 9.7 0 18.578-6.476 21.245-16.293L319.95 95.13c3.165-11.722-3.81-23.794-15.53-26.93M142.881 152.603c-7.882-9.289-21.684-10.373-31.002-2.549L7.765 238.314A22.035 22.035 0 000 255.105a21.914 21.914 0 007.765 16.732l104.114 88.378c4.131 3.516 9.2 5.216 14.24 5.216 6.213 0 12.425-2.638 16.762-7.736 7.853-9.26 6.71-23.15-2.55-31.003L55.94 255.105l84.393-71.528c9.26-7.854 10.402-21.714 2.55-30.974M503.585 238.423l-104.142-88.378c-9.172-7.794-23.09-6.74-30.973 2.55-7.854 9.26-6.71 23.12 2.549 30.973l84.363 71.587-84.363 71.528c-9.26 7.853-10.403 21.714-2.55 30.973 4.338 5.158 10.55 7.766 16.762 7.766 5.04 0 10.08-1.7 14.212-5.187l104.142-88.29a22.02 22.02 0 007.766-16.76 22.02 22.02 0 00-7.766-16.762" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconEmbed = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconEmbed.defaultProps = {
  theme,
};
IconEmbed.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconEmbed.displayName = 'IconEmbed';
export { IconEmbed };
